import { Controller } from "stimulus";
import { debounce } from 'lodash';

export default class extends Controller {
  static targets = ['policyTrainingsField', 'applyAllToggle']

  hideButton (event) {
    let form = event.target.closest('form')

    if (form.checkValidity()) {
      $(event.target).hide()
    }
  }

  copyText(event) {
    copyTextToClipboard($(event.target).closest('a').data('text'));

    var modalTarget = event.currentTarget.dataset.type
    $(`#copy-paste-message-${modalTarget}`).removeClass('d-none')
  }

  toggleTrainingsField(event) {
    if(this.hasPolicyTrainingsFieldTarget) {
      const trainingsField = $(this.policyTrainingsFieldTarget);
      if(event.target.checked) {
        trainingsField.val(null).trigger('change');
        trainingsField.closest('.form-group').hide();
        trainingsField.prop('required', false)
      } else {
        trainingsField.closest('.form-group').show();
        trainingsField.closest('.form-group').addClass('d-block-select2');
        trainingsField.prop('required', true)
      }
    }
  }
}
